import { Component } from '@angular/core';
import { ContextService } from '@apply4u/services/context-service';

@Component({
    templateUrl: './smart-layout.component.html',
    styleUrls: ['../smart-layout.component.css'],
})
export class SmartLayoutComponent {

    constructor(public contextService: ContextService) {
    }

    ngOnInit() {
    }
}
